
import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const CourseInstructorSection = () => (
  <div className="mb-4 rounded-lg bg-white/80 shadow flex flex-col md:flex-row items-start gap-8 p-6 border border-kaija-sage">
    <img
      src="/images/received_251291397735991-01.jpeg"
      alt="Kaija Alliksaar"
      className="w-32 h-32 object-cover rounded-full shadow"
    />
    <div>
      <h3 className="text-lg font-semibold mb-1">Kaija Alliksaar</h3>
      <p className="mb-2 text-gray-700 text-sm">
        ICF sertifitseeritud traumateadlik somaatiline enesejuhtimise coach, kellel on üle 15 aasta juhtimiskogemust.
      </p>
      <p className="mb-4 text-gray-700 text-sm italic">
        „Usun, et muutus algab sellest, kui õpime mõistma oma keha, reaktsioone ja vajadusi. See on võti sisemise rahu ja selguse juurde."
      </p>
      <Button asChild variant="link" className="p-0 text-kaija-accent font-semibold">
        <Link to="/about">
          Loe rohkem <ArrowRight className="inline-block h-4 w-4 ml-1" />
        </Link>
      </Button>
    </div>
  </div>
);

export default CourseInstructorSection;
